const isProduction = true;

const baseApiUrl = isProduction
  ? "https://norqain-watch-configurator.gadget.app/config"
  : "https://norqain-watch-configurator--development.gadget.app/config";

const createApiUrl = `${baseApiUrl}/createSavedConfig`;
const updateApiUrl = `${baseApiUrl}/updateSavedConfig`;

let userEmail;
let customerId;

document.addEventListener("DOMContentLoaded", () => {
  // Dohvati vrednosti iz hidden input polja
  const userIdInput = document.getElementById("userid");
  const emailInput = document.getElementById("email");

  if (userIdInput && emailInput) {
    customerId = userIdInput.value;
    userEmail = emailInput.value;
    console.log("User ID from hidden input:", customerId);
    console.log("User Email from hidden input:", userEmail);
  } else {
    console.error("Hidden input fields for user ID or email are missing.");
  }

  const popupWrapper = document.getElementById("new-config-popup-wrapper");
  const loggedInPopup = document.getElementById("new-popup-logged-in");
  const notLoggedInPopup = document.getElementById("new-popup-not-logged-in");

  if (!popupWrapper || !loggedInPopup || !notLoggedInPopup) {
    console.error("One or more popup elements are missing in the DOM.");
    return;
  }

  document.getElementById("saveConfig").addEventListener("click", () => {
    if (customerId) {
      loggedInPopup.classList.remove("hidden");
      notLoggedInPopup.classList.add("hidden");
    } else {
      notLoggedInPopup.classList.remove("hidden");
      loggedInPopup.classList.add("hidden");
    }

    popupWrapper.classList.remove("hidden");
  });

  document
    .getElementById("new-close-popup-btn-logged-in")
    .addEventListener("click", closePopup);
  document
    .getElementById("new-close-popup-btn-not-logged-in")
    .addEventListener("click", closePopup);

  document
    .getElementById("new-popup-cancel-btn-logged-in")
    .addEventListener("click", closePopup);
  document
    .getElementById("new-popup-cancel-btn-not-logged-in")
    .addEventListener("click", closePopup);

  function closePopup() {
    popupWrapper.classList.add("hidden");
  }

  document
    .getElementById("new-popup-confirm-btn-logged-in")
    .addEventListener("click", async () => {
      await createNewConfiguration();
      closePopup();
    });

  document
    .getElementById("new-popup-confirm-btn-not-logged-in")
    .addEventListener("click", async () => {
      const emailInputField = document.getElementById("new-popup-email-input");
      if (!emailInputField.value) {
        alert("Please enter a valid email address.");
        return;
      }

      userEmail = emailInputField.value;
      await createNewConfiguration();
      closePopup();
    });

  async function createNewConfiguration() {
    const endpoint = window.hexCode ? updateApiUrl : createApiUrl;
    try {
      const response = await fetch(endpoint, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          email: userEmail,
          customerId,
          finalConfig: window.finalConfiguration,
          ...(window.hexCode && { hexCode: window.hexCode }),
        }),
      });
      if (response.ok) {
        console.log("Configuration saved successfully.");
        if (customerId) {
          window.location.href = "/account?tab=saved-configurations";
        }
      } else {
        console.error("Failed to save configuration.");
      }
    } catch (error) {
      console.error("Error:", error);
    }
  }
});
